export default __webpack_public_path__ + "503f0a0385fd7973c8f0d03fd3be3167.png";